import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
/*
 * Constants.ts
 */
export class ApiConstants extends SlingoConstants {
}
ApiConstants.PROPERTY_PARAMS = "params";
ApiConstants.PROPERTY_CHANCE_GAME = "chanceGame";
ApiConstants.PROPERTY_WIN_LINES = "win-lines";
ApiConstants.PROPERTY_WIN_LINES_NUMBERS = "fruits";
ApiConstants.PROPERTY_WIN_LINES_JOKERS = "wilds";
ApiConstants.PROPERTY_SYMBOL_HINT = "symbolHint";
ApiConstants.PROPERTY_SCATTER_WIN = "scatter";
ApiConstants.PROPERTY_WINLINE_WIN = "winline";
ApiConstants.PROPERTY_WINNINGS = "winnings";
ApiConstants.CELL_COUNT = 11;
//# sourceMappingURL=ApiConstants.js.map